import { render, staticRenderFns } from "./UserStatistics.vue?vue&type=template&id=1b48c0dc&"
import script from "./UserStatistics.vue?vue&type=script&lang=js&"
export * from "./UserStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports